import React from 'react';
import classnames from 'classnames';

import './Announcement.module.css';

const Announcement = ({
  children,
  className = null,
  left = false,
  vertical = false
}) => {
  return (
    <div
      className={className}
      styleName={classnames('box', { left, vertical })}
    >
      <i className="fl-announcement" />
      <div styleName="content">{children}</div>
    </div>
  );
};

export default Announcement;
